
export function subcategoryPath(categoryId: string, subcategoryId: string): string {
  return `/categories/${categoryId}/subcategories/${subcategoryId}`;
}
